import { Subject as J } from "rxjs";
import { merge as Q, get as I } from "lodash-es";
import { replacePlaceholders as M, redirect as K } from "@loopia-group/utils";
import u from "i18next";
import Y from "axios";
var N = /* @__PURE__ */ ((e) => (e[e.rollup = 0] = "rollup", e[e.webpack = 1] = "webpack", e))(N || {}), x = /* @__PURE__ */ ((e) => (e.ADMIN = "admin", e.CARY = "cary", e.LOOPIA = "loopia", e.ACTIVE_24 = "active24", e))(x || {}), P = /* @__PURE__ */ ((e) => (e.WEBSUPPORT_SK = "sk-ws", e.SK_WEBSUPPORT_CZ = "cz-ws", e.WEBSUPPORT_HU = "hu-ws", e.WEBSUPPORT_SE = "se-ws", e.SK_WEBSUPPORT_HU = "hu-skws", e.ACTIVE_24_SK = "sk-a24", e.ACTIVE_24_CZ = "cz-a24", e.SK_WEBSUPPORT_AT = "at-ws", e.LOOPIA_SE = "se-lp", e.LOOPIA_NO = "no-lp", e))(P || {});
const z = new J(), Me = z.asObservable(), y = {
  // default config values
  companyCountry: "SK",
  bounds: {
    east: 16.8799829444,
    south: 47.7584288601,
    west: 22.5581376482,
    north: 49.5715740017
  },
  languages: {},
  currency: "EUR",
  validationApiUrl: "https://api-cart.websupport.sk/",
  bundler: N.webpack
};
function je(e) {
  Q(y, e), z.next(y);
}
let B, E, L, W;
const $e = (e, s, t, n, a) => {
  B = e, E = s, L = t, W = n;
}, Ie = () => ({
  responseAction: ee,
  actionClicked: le
}), ee = async (e, s, t) => ({
  actionPromise: new Promise((a) => {
    a(ae(e, s, t));
  }),
  killAction: () => {
  }
});
function se(e, s) {
  return (e == null ? void 0 : e.action) === "poll" && e.url || (s == null ? void 0 : s.poll);
}
function te(e, s) {
  return (e == null ? void 0 : e.action) === "redirect" ? e.url || (s == null ? void 0 : s.redirect) : (e == null ? void 0 : e.redirectTo) || (s == null ? void 0 : s.redirect);
}
function v(e, s = "toggle") {
  if (e != null && e.openModal) {
    const t = L[e.openModal];
    W(() => {
      t ? t[s]() : console.error(`Modal ${e.openModal} not found`);
    });
  }
}
async function ne(e, s, t) {
  return v(e, "show"), s ? (await T(s, t), v(e, "hide"), !1) : (v(e, "hide"), !1);
}
const ae = async (e, s, t) => {
  const n = s["content-disposition"];
  if (n == null ? void 0 : n.includes("attachment")) {
    const p = n.replaceAll(/"/g, "").slice(n.indexOf("=") + 1);
    return re(e, s, p), !1;
  }
  const o = I(e, "data", e), i = se(e, t), l = 30, m = M(i, o);
  let d = M(te(e, t), o);
  if (m) {
    if (t != null && t.openModal)
      return ne(t, m, l);
    d = await T(m, l) || d;
  }
  return d ? (K(d), !0) : t != null && t.reload ? (window.location.reload(), !0) : (v(t), oe(s), t != null && t.reloadComponents && ie(t.reloadComponents), !1);
};
function oe(e) {
  var s;
  (s = e["x-flash-messages"]) != null && s.length && (E ? E.setFlashMessages(JSON.parse(e["x-flash-messages"])) : console.error("Message service not configured"));
}
function ie(e) {
  e.forEach((s) => {
    var t;
    (t = L[s]) == null || t.reload();
  });
}
const T = (e, s) => new Promise(async (t, n) => {
  if (s <= 0)
    return n("Server polling exceeded it's connection limit.");
  try {
    const a = await B({ url: e });
    if (a.status === 200)
      return s = -1, t(a.data.redirectTo);
  } catch {
  }
  setTimeout(async () => {
    try {
      t(await T(e, s));
    } catch (a) {
      n(a);
    }
  }, 2e3);
}), re = (e, s, t) => {
  const n = new Blob([e], { type: s["content-type"] }), a = URL.createObjectURL(n), o = document.createElement("a");
  o.href = a, o.setAttribute("download", t), document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(a);
}, le = async (e, s, t) => {
  if (s == null || s.$emit("action-clicked", e), s != null && s.isDisabled) {
    s == null || s.disabledBulkActionData.disabledBulkActionHandler(e.name);
    return;
  }
  return e.ajax ? s == null || s.$emit("ajax-action-call", e) : typeof e.clicked == "function" ? e.clicked(e) : e.modalRef && (s != null && s.$root.$refs[e.modalRef]) ? await ce(e, s) : e.url && ue(e, t), !1;
}, ue = (e, s) => {
  var t;
  ((t = e == null ? void 0 : e.attributes) == null ? void 0 : t.target) === "_blank" ? window.open(s || e.url, "_blank") : K(s || e.url);
}, ce = async (e, s) => {
  e.rowData && (s == null ? void 0 : s.$root).$wData.set("modalData", {
    action: e,
    rowData: e.rowData
  });
  const t = e, n = e.rowData;
  await (s == null ? void 0 : s.$nextTick());
  let a = s == null ? void 0 : s.$root.$refs[e.modalRef];
  a && e.refIndex !== void 0 && (a = I(a, e.refIndex, a)), a && (a.setModalData(e.rowData), a.toggle()), s != null && s.emitInActions && (await (s == null ? void 0 : s.$nextTick()), s == null || s.emitInActions("show-cta-modal", e.modalRef, { cta: t, rowData: n }));
}, fe = (e, s) => {
  const t = e[s];
  return t ? typeof t == "function" ? t() : Promise.resolve(t) : new Promise((n, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(a.bind(null, new Error("Unknown variable dynamic import: " + s)));
  });
};
let F = async (e) => ({}), ge = [];
function Ke() {
  return {
    setLang: u.changeLanguage,
    getLang: () => u.language,
    getLanguages: () => u.languages,
    t: u.t,
    i18next: u
  };
}
async function Ne(e) {
  return e.loadLanguage && (F = e.loadLanguage), ge = e.supportedLanguages, await u.init({
    lng: e.language,
    supportedLngs: e.supportedLanguages,
    fallbackLng: ["en-US", "en-SE"],
    lowerCaseLng: !1,
    defaultNS: e.defaultNS,
    ns: ["app", "uikit"],
    debug: !!e.debug
  }), u.on("languageChanged", j), await j(e.language), u;
}
function j(e) {
  return Promise.all([
    de(e),
    me(e)
  ]);
}
async function de(e) {
  const s = await F(e);
  u.addResourceBundle(e, "app", s, !0, !0);
}
async function me(e) {
  const s = await fe(/* @__PURE__ */ Object.assign({ "./translations/wsk.cs-CZ.json": () => import("./wsk.cs-CZ-bdddeac7.js"), "./translations/wsk.en-SE.json": () => import("./wsk.en-SE-ea71c50e.js"), "./translations/wsk.en-US.json": () => import("./wsk.en-US-cb313aa1.js"), "./translations/wsk.hu-HU.json": () => import("./wsk.hu-HU-36fd2278.js"), "./translations/wsk.sk-SK.json": () => import("./wsk.sk-SK-40850c14.js"), "./translations/wsk.sv-SE.json": () => import("./wsk.sv-SE-d9085144.js"), "./translations/wsk.xx-XX.json": () => import("./wsk.xx-XX-3730ab49.js") }), `./translations/wsk.${e}.json`);
  u.addResourceBundle(e, "uikit", s.wsk, !0, !0);
}
const we = {
  en: "English",
  gb: "English",
  sk: "Slovensky",
  cs: "Česky",
  cz: "Česky",
  hu: "Magyar",
  de: "Deutsch",
  sv: "Swedish",
  se: "Swedish"
  // xx: 'Crowdin',
}, ze = (e) => we[e.toLowerCase()] || e;
function Be(e) {
  const t = [
    "cs-CZ",
    "sv-SE"
  ].includes(e) ? 1 : 0;
  let n = e.split("-")[t] || "";
  return n.toLowerCase() === "en" && (n = "gb"), n;
}
function We(e) {
  let s = [];
  return [P.WEBSUPPORT_SE, P.LOOPIA_SE].includes(e) ? s = [
    "en-SE",
    "sv-SE"
  ] : s = [
    "cs-CZ",
    "hu-HU",
    "en-US",
    "sk-SK"
  ], s;
}
const pe = [
  he,
  ve
], _e = (e, s) => {
  for (const t of pe) {
    const n = t(e, s);
    if (n)
      return n;
  }
  return be(e, s);
};
function he(e, s) {
  var t, n, a, o, i, l, m, d, p, O;
  if (((t = e == null ? void 0 : e.response) == null ? void 0 : t.status) === 422 && ((a = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : a.type) === "/errors/validation" && typeof ((i = (o = e == null ? void 0 : e.response) == null ? void 0 : o.data) == null ? void 0 : i.violations) && Array.isArray((m = (l = e == null ? void 0 : e.response) == null ? void 0 : l.data) == null ? void 0 : m.violations))
    return (O = (p = (d = e == null ? void 0 : e.response) == null ? void 0 : d.data) == null ? void 0 : p.violations) == null ? void 0 : O.reduce((D, k) => (D[k.errors[0].propertyPath] = {
      value: k.errors[0].translation,
      payload: {
        title: e.title,
        text: k.errors[0].translation,
        icon: !0,
        closable: !0,
        type: "error"
      },
      error: e
    }, D), {});
}
function ve(e, s) {
  var t, n, a, o, i;
  if ((e == null ? void 0 : e.code) === "ERR_NETWORK" && (e == null ? void 0 : e.name) === "AxiosError" && (e == null ? void 0 : e.message) === "Network Error")
    return {
      0: {
        value: "Unable to Connect ",
        payload: {
          title: s("uikit:wsk.message_service.error.axios.title"),
          text: s("uikit:wsk.message_service.error.axios.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
  if (((t = e == null ? void 0 : e.response) == null ? void 0 : t.status) === 401)
    return {
      0: {
        value: "Authentication error",
        payload: {
          text: s("uikit:wsk.message_service.error.status_401.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
  if (((n = e == null ? void 0 : e.response) == null ? void 0 : n.status) === 403)
    return {
      0: {
        value: "Access denied",
        payload: {
          text: s("uikit:wsk.message_service.error.status_403.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
  if ((e == null ? void 0 : e.code) === "ERR_BAD_REQUEST" && (e == null ? void 0 : e.name) === "AxiosError" && (e == null ? void 0 : e.message) === "Request failed with status code 404")
    return {
      0: {
        value: "Not found",
        payload: {
          text: s("uikit:wsk.message_service.error.status_404.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
  if (((a = e == null ? void 0 : e.response) == null ? void 0 : a.status) === 407)
    return {
      0: {
        value: "Proxy authentication required",
        payload: {
          text: s("uikit:wsk.message_service.error.status_407.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
  if (((o = e == null ? void 0 : e.response) == null ? void 0 : o.status) === 408)
    return {
      0: {
        value: "Connection timeout",
        payload: {
          text: s("uikit:wsk.message_service.error.status_408.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
  if (((i = e == null ? void 0 : e.response) == null ? void 0 : i.status) === 500)
    return {
      0: {
        value: "Server error",
        payload: {
          text: s("uikit:wsk.message_service.error.status_500.text"),
          icon: !0,
          closable: !0,
          type: "error"
        },
        error: e
      }
    };
}
function be(e, s) {
  let t = s("uikit:wsk.message_service.error.unexpected.text"), n = new Error("Unexpected error", e);
  return e instanceof Error ? (e.message && (t = e.message), n = e) : typeof e == "string" && (t = e, n = new Error(e)), {
    0: {
      value: t,
      payload: {
        title: s("uikit:wsk.message_service.error.unexpected.title"),
        text: t,
        icon: !0,
        closable: !0,
        type: "error"
      },
      error: n
    }
  };
}
let c = {};
const f = {
  messages: {},
  topics: {}
};
let q = (e, s) => e, b = () => {
}, H = (e) => e;
function Fe(e) {
  e.postInterceptor && (q = e.postInterceptor), e.translate && (H = e.translate), e.onChange && (b = e.onChange);
}
function qe() {
  return {
    // Read
    getMessages: (e) => c[e],
    getAllMessages: () => c,
    subscribeMessage: (e, s) => $("messages", e, s),
    subscribeTopic: (e, s) => $("topics", e, s),
    // Posting
    postMessage: (e, s, t = []) => {
      _(e, s, h(t));
    },
    postError: (e, s, t = []) => {
      _(e, s, h(t, ["error"]));
    },
    handleUnstructuredError: (e, s, t = []) => {
      const n = _e(s, H), a = Object.entries(n);
      if (a.length === 1)
        return _(e, a[0][1], h(t, ["error"]));
      a.forEach(([o, i]) => {
        _(e + "." + o, i, h(t, ["error"]));
      });
    },
    // Clear
    clearMessages: () => {
      c = {}, b(c);
    },
    deleteMessage: (e) => {
      delete c[e], b(c);
    }
  };
}
function $(e, s, t) {
  f[e][s] || (f[e][s] = []);
  const n = f[e][s].length, a = () => f[e][s].splice(n, 1);
  return f[e][s].push({ id: n, callback: t, unsubscribe: a }), f[e][s][n];
}
function _(e, s, t) {
  var a;
  s.toString = function() {
    return this.value;
  }, c[e] = q(s, t);
  const n = (o) => o.callback(s, e, t);
  (a = f.messages[e]) == null || a.forEach(n), t.forEach((o) => {
    var i;
    return (i = f.topics[o]) == null ? void 0 : i.forEach(n);
  }), b(c);
}
function h(e, s = []) {
  const t = typeof e == "string" ? [e] : e;
  return s.forEach((n) => {
    t.includes(n) || t.push(n);
  }), t;
}
let U;
const Z = [], V = (e) => U === e, A = (e) => {
  U = e, Z.forEach((s) => {
    s(e);
  });
};
function He() {
  return {
    isTheme: V,
    setTheme: A,
    theme: U
  };
}
function Ze(e) {
  A(e.theme), e.onTheme && ke(e.onTheme), e.env === "development" && (window.setTheme = A, window.isTheme = V);
}
function ke(e) {
  Z.push(e);
}
const Se = Y.create({ withCredentials: !1 }), Ve = () => ({
  getAutofillSuggestions: Pe
});
function Pe({
  name: e = null,
  cin: s = null,
  limit: t = 5,
  filter: n = "active"
}) {
  const a = "f639d8d3ff0b9172721f468f8d71c99699cbcda3366b6ac7278446f012fc538483a62815865264cc";
  if (!e && !s)
    return Promise.reject();
  const o = e ? `name:${e}` : `cin:${s}`, i = "https://autoform.ekosystem.slovensko.digital/api/corporate_bodies/search?q=" + encodeURIComponent(o) + "&limit=" + encodeURIComponent(t) + "&filter=" + encodeURIComponent(n) + "&private_access_token=" + a;
  return Se.get(i).then((l) => l.data).catch(() => []);
}
let w = null;
const S = new Object(null);
let C, R, r, g;
const Ge = () => ({
  askForLocation: ye,
  getPlacePredictions: Ee,
  getPlaceAddress: Ae,
  parseCityFromComponents: Te,
  parseStreetFromComponents: Le,
  parseAddressComponents: G
}), Xe = (e) => {
  g = e, r = typeof g > "u" ? null : g, r || X(100), R = r && r.maps ? new r.maps.places.AutocompleteService(
    document.createElement("input")
  ) : {}, C = r && r.maps ? new r.maps.places.PlacesService(document.createElement("div")) : {};
};
function ye() {
  !w && navigator.geolocation && navigator.geolocation.getCurrentPosition(
    (e) => {
      w = e.coords;
    },
    () => {
    },
    {
      enableHighAccuracy: !1,
      maximumAge: 5e3
    }
  );
}
function Ee(e, s = "(cities)") {
  if (!r)
    return Promise.reject(new Error("google not loaded"));
  if (!e)
    return Promise.resolve([]);
  const t = `${e}::${s}`;
  return S[t] ? Promise.resolve(S[t]) : new Promise((n, a) => {
    R.getPlacePredictions(
      {
        input: e,
        types: [s],
        // specifying location and radius did not enhance results, for example for
        // Sedmerovec 93 address.. it did not find it neither
        // therefore I am not going to make code more complex, without any value
        ...w ? {
          radius: 5e3,
          location: new g.maps.LatLng(
            w.latitude,
            w.longitude
          )
        } : {
          // fallbacks to whole europe
          bounds: y.bounds || {
            east: -24.550781,
            south: 34.741612,
            west: 40.605468,
            north: 71.244356
          }
        }
      },
      (o, i) => {
        i === g.maps.places.PlacesServiceStatus.OK ? (S[t] = o, n(o)) : a({ results: o, status: i });
      }
    );
  });
}
function Ae(e) {
  return new Promise((s, t) => {
    C.getDetails(
      {
        placeId: e,
        fields: ["address_components"]
      },
      (n, a) => {
        a === g.maps.places.PlacesServiceStatus.OK ? s(G(n.address_components)) : t({ result: n, status: a });
      }
    );
  });
}
function Le(e) {
  const s = e.route, t = e.street_number || e.queryNumberParts || "";
  return s && t ? `${s} ${t}` : s || t;
}
function Te(e) {
  return e.postal_town || e.locality || e.sublocality || e.sublocality_level_5 || e.sublocality_level_4 || e.sublocality_level_3 || e.sublocality_level_2 || e.sublocality_level_1 || e.administrative_area_level_5 || e.administrative_area_level_4 || e.administrative_area_level_3 || e.administrative_area_level_2 || e.administrative_area_level_1 || "";
}
function G(e = []) {
  const s = {}, t = e.length;
  for (let n = 0; n < t; ++n) {
    const a = e[n], o = a.types;
    for (let i = 0; i < o.length; ++i) {
      const l = o[i];
      s[l] = a.long_name, l === "country" && (s.country_code = a.short_name);
    }
  }
  return s;
}
function X(e) {
  setTimeout(() => {
    e > 3e4 || (r = typeof g > "u" ? null : g, r ? (R = new r.maps.places.AutocompleteService(), C = new r.maps.places.PlacesService(
      document.createElement("div")
    )) : X(e *= 2));
  }, e);
}
export {
  N as Bundler,
  P as CompanyId,
  x as Theme,
  le as actionClicked,
  y as config,
  Me as configObservable,
  We as getAllowedLanguages,
  ze as getLanguageName,
  ge as languages,
  Be as localeToFlagCode,
  ke as onTheme,
  ee as responseAction,
  je as setConfigValues,
  $e as setupActions,
  Xe as setupGoogleAPI,
  Ne as setupI18n,
  Fe as setupMessages,
  Ze as setupTheming,
  we as supportedLanguages,
  Ie as useActions,
  Ve as useAutoComplete,
  Ge as useGoogleAPI,
  Ke as useI18n,
  qe as useMessages,
  He as useTheming
};
//# sourceMappingURL=index.es.js.map
